module.exports = __webpack_public_path__ + "static/media/logo197.1974e615.png";